import { render, staticRenderFns } from "./BananaList.vue?vue&type=template&id=5c22f725"
import script from "./BananaList.vue?vue&type=script&lang=js"
export * from "./BananaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports